var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wishlist"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29490",
    "data-name": "Rectangle 29490",
    width: 14,
    height: 14,
    transform: "translate(39 374)",
    fill: "#6a6f73",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_709",
    "data-name": "Mask Group 709",
    transform: "translate(-39 -374)",
    clipPath: "url(#wishlist)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_13_",
    "data-name": "svgexport-6 (13)",
    transform: "translate(39 375.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12960",
    "data-name": "Path 12960",
    d: "M13.395,2.842A3.575,3.575,0,0,0,11.75,1.45a3.958,3.958,0,0,0-2.5-.168A5.339,5.339,0,0,0,7,2.516,5.339,5.339,0,0,0,4.747,1.282a3.956,3.956,0,0,0-2.5.168A3.575,3.575,0,0,0,.605,2.842,4.11,4.11,0,0,0,0,5.125c.068,3.754,5.66,7.167,6.781,7.814a.438.438,0,0,0,.437,0c1.12-.646,6.713-4.06,6.781-7.814a4.11,4.11,0,0,0-.6-2.283Zm-.27,2.267c-.022,1.214-.831,2.629-2.34,4.092A21.373,21.373,0,0,1,7,12.053,21.359,21.359,0,0,1,3.216,9.2C1.707,7.738.9,6.323.876,5.109A2.885,2.885,0,0,1,2.589,2.257a2.916,2.916,0,0,1,1.135-.225,4.259,4.259,0,0,1,2.964,1.4.438.438,0,0,0,.624,0,3.779,3.779,0,0,1,4.1-1.171,2.885,2.885,0,0,1,1.714,2.852Z",
    transform: "translate(0 -1.156)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.e15a3c513c6b2ca34d9e577059dc7a4f.svg";
export { ForwardRef as ReactComponent };